import { decodeJwt, CompactEncrypt, compactDecrypt } from "jose";
import JSEncrypt from "jsencrypt";

// Hybrid encryption function
export async function encryptData(data, backendPublicKey) {
  const json = JSON.stringify(data);

  const aesKey = crypto.getRandomValues(new Uint8Array(32)); // 256-bit
  const iv = crypto.getRandomValues(new Uint8Array(16));

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    aesKey,
    { name: "AES-CBC" },
    false,
    ["encrypt"]
  );

  const encryptedData = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    cryptoKey,
    new TextEncoder().encode(json)
  );

  const rsa = new JSEncrypt();
  rsa.setPublicKey(backendPublicKey);

  const encryptedAesKey = rsa.encrypt(bytesToBase64(aesKey));
  if (!encryptedAesKey) throw new Error("RSA encryption failed");

  return {
    encrypted_key: encryptedAesKey,
    iv: bytesToBase64(iv),
    data: bytesToBase64(new Uint8Array(encryptedData)),
  };
}

// Convert bytes to Base64
function bytesToBase64(bytes) {
  return btoa(String.fromCharCode(...bytes));
}

export function decodeToken(token) {
  try {
    const payload = decodeJwt(token);
    return payload;
  } catch (err) {
    console.error('Invalid token:', err);
    return null;
  }
}
export async function verifyToken(secreteKey, token) {
  try {
    const base64Key = base64DecodeToString(secreteKey);

    // Base64 → Uint8Array (browser-safe)
    const key = Uint8Array.from(
      atob(base64Key),
      c => c.charCodeAt(0)
    );

    const { plaintext } = await compactDecrypt(
      token,
      key
    );

    const json = JSON.parse(new TextDecoder().decode(plaintext));
    return json;

  } catch (err) {
    console.error("Decryption failed or invalid token:", err);
    return null;
  }
}
function base64DecodeToString(base64) {
  return decodeURIComponent(
    escape(atob(base64))
  );
}
